import React, { Fragment } from "react";
import { LazyloadImage } from "src/components";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import { IImageType } from "../../../../../../../../pages/OrderFunnel/Payment/Payment.component";
import { media } from "../../../../../../../../theme";

import { paymentIcons } from "./paymentIcons";

const List = styled.ul`
  display: flex;
  list-style: none;
  justify-content: space-around;
  align-items: center;
  padding: 0;
  margin: 10px 0;

  &:first-of-type {
    margin-top: 28px;
  }

  ${media.laptop} {
    flex-wrap: wrap;
    justify-content: flex-start;
    max-width: 85%;

    &:first-of-type {
      margin-top: 0;
    }
  }
`;

const ListItem = styled.li`
  display: table;
  text-align: center;

  & > img {
    max-width: 100%;
    vertical-align: middle;
  }

  ${media.laptop} {
    padding: 8px 15px 15px 0;

    & > img {
      width: 45px;
    }
  }
`;

interface IImage {
  image: IImageType[];
  index?: number;
}

const renderMobileList = ({ image, index }: IImage): JSX.Element => {
  return (
    <List key={`paymentLine-${index}`}>
      {image.map((icon: IImageType, i: number) => {
        return (
          <ListItem key={`paymentIcon-${i}`}>
            <LazyloadImage height={28}>
              <img src={icon.url} width={icon.width} alt={icon.name} />
            </LazyloadImage>
          </ListItem>
        );
      })}
    </List>
  );
};

const renderLaptopList = ({ image, index }: IImage): JSX.Element => {
  return (
    <Fragment key={`paymentLine-${index}`}>
      {image.map((icon: IImageType, i: number) => {
        return (
          <ListItem key={`paymentIcon-${i}`}>
            <img src={icon.url} width={icon.width} alt={icon.name} />
          </ListItem>
        );
      })}
    </Fragment>
  );
};

const MobileList = (): JSX.Element => (
  <>
    {paymentIcons.map(
      (image: IImageType[], index: number): JSX.Element =>
        renderMobileList({ image, index })
    )}
  </>
);

const LaptopList = (): JSX.Element => (
  <List>
    {paymentIcons.map(
      (image: IImageType[], index: number): JSX.Element =>
        renderLaptopList({ image, index })
    )}
  </List>
);

const PaymentIcons = (): JSX.Element => {
  const { mdOrDown } = useRenderOn();

  return mdOrDown ? <MobileList /> : <LaptopList />;
};

export default PaymentIcons;
